import { Component } from 'react';
import clone from 'lodash.clone';

export default class FormTemplate extends Component {
	constructor(props) {
		super(props);
		this.myRefs = {};
	}

	getValue = () => {
		let value = {};
		if (this && this.state && this.state.value) {
			value = clone(this.state.value || {});
		}
		for (let i in this.myRefs) {
			if (this.myRefs && this.myRefs[i]) {
				value[i] = this.myRefs[i].getValue();
			}
		}
		return value;
	};

	isValid = () => {
		let valid = true;
		for (let i in this.myRefs) {
			if (this.myRefs && this.myRefs[i]) {
				let val = this.myRefs[i].isValid();
				if (!val) {
					valid = false;
				}
			}
		}
		return valid;
	};
}



// WEBPACK FOOTER //
// ./src/components/templates/formTemplates/FormTemplate.jsx